import React from 'react';
import AppRoutes from './navigation/AppRoutes';

function App() {
  return <AppRoutes />;
}

export default App;
